import React, { useMemo } from 'react';
import { Badge, BadgePriority, RadioButton, RadioButtonTheme } from 'wix-ui-tpa/cssVars';
import { classes } from './DeliveryOptionsPicker.st.css';
import { useDeliverySectionData } from '../../provider/useDeliverySectionContext';
import { DeliveryOptionsPickerHooks } from './DeliveryOptionsPicker';
import { DeliveryInfoBox } from './DeliveryInfoBox/DeliveryInfoBox';
import { TimeSlotSelector } from './TimeSlotSelector/TimeSlotSelector';
import { ScheduledDeliverySelector } from './ScheduledDeliverySelector/ScheduledDeliverySelector';
import { SPECS } from '../../specs';
import { useLocaleKeys } from '../../locale-keys/LocaleKeys';
export const DeliveryOption = props => {
  const {
    deliveryOption
  } = props;
  const {
    isUpdatingShippingOption,
    setDeliveryMethodId,
    selectedDeliveryOption,
    hasPartialShippingOptions,
    experiments
  } = useDeliverySectionData();
  const localeKeys = useLocaleKeys();
  const isChecked = useMemo(() => (selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.groupId) === deliveryOption.groupId, [selectedDeliveryOption, deliveryOption.groupId]);
  const selectedOption = useMemo(() => {
    if (!isChecked) {
      return null;
    }
    return deliveryOption == null ? void 0 : deliveryOption.options.find(option => option.id === (selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.id));
  }, [isChecked, deliveryOption == null ? void 0 : deliveryOption.options, selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.id]);
  const isFree = useMemo(() => (deliveryOption == null ? void 0 : deliveryOption.price) === 0, [deliveryOption == null ? void 0 : deliveryOption.price]);
  const deliveryOptionId = useMemo(() => {
    return deliveryOption.options[0].id;
  }, [deliveryOption.options]);
  const shouldShowBadge = !(deliveryOption != null && deliveryOption.partial) && hasPartialShippingOptions && experiments[SPECS.SupportDeliveryProfilesPhase2];
  const shouldSeperateAdditionalFeeFromPrice = experiments[SPECS.separateAdditionalFee];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioButton, {
    "data-hook": DeliveryOptionsPickerHooks.deliveryOption({
      id: deliveryOption.groupId
    }),
    className: classes.radioButton,
    value: deliveryOption.groupId,
    checked: isChecked,
    label: deliveryOption.title,
    subtext: shouldSeperateAdditionalFeeFromPrice ? getSubtext(deliveryOption) : deliveryOption.subtitle,
    disabled: isUpdatingShippingOption,
    suffix: /*#__PURE__*/React.createElement("div", {
      className: classes.radioButtonSuffix
    }, shouldShowBadge && /*#__PURE__*/React.createElement(Badge, {
      "data-hook": DeliveryOptionsPickerHooks.deliveryOptionBadge(),
      className: classes.radioButtonBadge,
      priority: BadgePriority.secondary
    }, localeKeys.deliverySection.deliveryProfiles.availableAllItems.badge()), /*#__PURE__*/React.createElement("span", {
      key: deliveryOptionId,
      "data-hook": DeliveryOptionsPickerHooks.deliveryOptionPrice(),
      className: classes.priceTag
    }, isFree ? localeKeys.deliverySection.free.label() : deliveryOption.formattedPrice)),
    onChange: event => {
      if (event.type === 'click') {
        setDeliveryMethodId(deliveryOptionId, deliveryOption.groupId);
      }
    },
    theme: RadioButtonTheme.Box
  }), isChecked && /*#__PURE__*/React.createElement(React.Fragment, null, deliveryOption.hasTimeSlots ? /*#__PURE__*/React.createElement(TimeSlotSelector, {
    deliveryOption: deliveryOption
  }) : deliveryOption.options.length > 1 && /*#__PURE__*/React.createElement(ScheduledDeliverySelector, {
    deliveryOption: deliveryOption
  }), /*#__PURE__*/React.createElement(DeliveryInfoBox, {
    deliveryTime: selectedOption == null ? void 0 : selectedOption.deliveryTime,
    instructions: deliveryOption == null ? void 0 : deliveryOption.instructions,
    insideTimeSelector: deliveryOption.hasTimeSlots,
    isPickup: !!deliveryOption.pickupDetails
  })));
};
const getSubtext = deliveryOption => {
  if (!deliveryOption.subtitle && !deliveryOption.additionalFeeSubtitle) {
    return undefined;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, deliveryOption.subtitle && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, deliveryOption.subtitle), /*#__PURE__*/React.createElement("br", null)), deliveryOption.additionalFeeSubtitle && /*#__PURE__*/React.createElement("span", null, deliveryOption.additionalFeeSubtitle));
};
//# sourceMappingURL=DeliveryOption.js.map